import 'slick-carousel/slick/slick.min.js';


// $('.responsive').slick();

// By Chris Coyier & tweaked by Mathias Bynens

$(function() {

	// Find all YouTube videos
	var $allVideos = $('iframe[src^="http://www.youtube.com"]'),

		// The element that is fluid width
		$fluidEl = $('.item');

	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {
		// and remove the hard coded width/height
		$(this).data('aspectRatio', this.height / this.width)
			.removeAttr('height')
			.removeAttr('width');
	});

	// When the window is resized
	// (You'll probably want to debounce this)
	$(window).resize(function() {

		var newWidth = $fluidEl.width();

		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {
			var $el = $(this);

			$el.width(newWidth).height(newWidth * $el.data('aspectRatio'));
		});

	// Kick off one resize to fix all videos on page load
	}).resize();

});



$('body').prepend('<div class="vidcover"></div>');


$(window).resize( function(){
	var theWidth = $(window).width();
	var theHeight = $(window).height();
	var newWidth = (theHeight*1.77777778);
	var newHeight = (theWidth/1.77777778);

	if ( (theWidth > 1280) && (newHeight > theHeight )) {
		$('.videos').css({'width':theWidth, 'height':newHeight});
	}

	if ( (theHeight > 720) && (newWidth > theWidth )) {
		$('.videos').css({'height':theHeight, 'width':newWidth});
	}

	$('.vidcover').css({'height':theHeight, 'width':theWidth});
}).resize();



// WEBPACK FOOTER //
// ./theme_components/js/slick.js